<style scoped lang='scss'>
	.chat-file-loader {
		width: 100%;
		position: absolute;
		max-height: 250px;
		background-color: #fff;
		bottom: 50px;
		border-radius: 5px;
		box-shadow: 0px 2px 3px #ddd;
		padding: 15px;
		border: 1px solid #ddd;
		&.relative {
			position: relative;
			bottom: 0;
		}
		&.has-cursor {
			cursor: pointer;
		}
		.chat-file-loader-box {
			width: 100%;
			height: 100%;
			background-color: #fff;
			background-repeat: no-repeat;
			text-align: center;
			overflow-y: auto;
			.chat-file-loader-remove {
				width: 100%;
				height: 100%;
				position: absolute;
				bottom: 0;
				left: 0;
				height: 0;
				background: rgba(0, 0, 0, 0.6);
				transition: 0.3s;
				cursor: pointer;
			}
			.preview-image {
				height: auto;
				width: auto;
			}
			i {
				font-size: 100px;
				display: block;
				text-align: center;
				width: 100%;
				height: auto;
				line-height: 0;
			}
			span {
				color: #505050;
				font-size: 15px;
				font-weight: 700;
				display: block;
			}
		}
	}
</style>

<template>
	<div class="chat-file-loader">
		<div
		class="chat-file-loader-box"
		v-if="icons.image.includes(extension)"
		@click="gotoAttachmentUrl(url)"
		>
		<img class="image preview-image" :src="url" alt />
		<span>{{ name }}</span>
	</div>
	<div class="chat-file-loader-box" v-else @click="gotoAttachmentUrl(url)">
		<div class="chat-file-loader-remove"></div>
		<img v-if="imageIcons[extension] !== undefined" :src="imageIcons[extension]" />
		<img v-else :src="imageIcons.file" />
		<span>{{ name }}</span>
	</div>
	<button @click.prevent="sendAttachment" class="button">Send</button>
</div>
</template>

<script>
	export default {
		props: {
			url: {
				type: String,
				default: null
			},

			extension: {
				type: String,
				default: null
			},

			name: {
				type: String,
				default: null
			},

			canGotoAttachmentUrl: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				visible: true,
				imageIcons: {
					png:
					"https://cdn1.iconfinder.com/data/icons/hawcons/32/699055-icon-65-document-image-256.png",
					jpg:
					"https://cdn1.iconfinder.com/data/icons/hawcons/32/699055-icon-65-document-image-256.png",
					file:
					"https://cdn1.iconfinder.com/data/icons/hawcons/32/699055-icon-65-document-image-256.png",
					zip:
					"https://cdn1.iconfinder.com/data/icons/hawcons/32/699233-icon-124-document-file-zip-256.png",
					mp3:
					"https://cdn1.iconfinder.com/data/icons/hawcons/32/700029-icon-71-document-file-mp3-512.png",
					mpga:
					"https://cdn1.iconfinder.com/data/icons/hawcons/32/700029-icon-71-document-file-mp3-512.png",
					js:
					"https://cdn4.iconfinder.com/data/icons/file-names-25/512/1-256.png",
					html:
					"https://cdn1.iconfinder.com/data/icons/hawcons/32/700034-icon-76-document-file-html-256.png",
					xhtml:
					"https://cdn1.iconfinder.com/data/icons/hawcons/32/700034-icon-76-document-file-html-256.png",
					htm:
					"https://cdn1.iconfinder.com/data/icons/hawcons/32/700034-icon-76-document-file-html-256.png",
					php:
					"https://cdn1.iconfinder.com/data/icons/hawcons/32/699595-icon-86-document-file-php-256.png"
				},
				icons: {
					image: ["png", "jpg", "jpeg", "svg", "gif"],
					files: ["zip", "rar", "pdf"],
					music: ["mp3"],
					video: ["mov", "mp4", "avi"]
				}
			};
		},

		methods: {
			sendAttachment() {
				this.$emit("sendAttachment");
			},

			notVisible() {
				this.visible = false;
			},

			setBackgroundImage() {
				return (
					"background-image: url(" +
					this.url +
					"); background-size: contain;background-repeat: no-repeat;background-position: center;"
				);
			},

			gotoAttachmentUrl(url) {
				if (this.canGotoAttachmentUrl == true) {
					window.open(url, "_blank");
				}
			}
		}
	};
</script>